<div class="flex flex-col gap-2" #containerElementCondition>
  @if (conditions && conditions.controls.length === 0) {
    <div class="flex items-center justify-center w-full p-4 text-sm text-white/50">
      Click the "Add Condition" button to start building your filter
    </div>
  }

  @if (conditions && conditions.controls.length > 0) {
    @for (condition of conditions.controls; track condition) {
      <div class="relative flex w-full">
        <nrc-permission-condition-builder
          class="flex flex-1"
          [condition]="condition"
          [collectionName]="collectionName"
          [overflowParentElement]="containerElementCondition"
        />
        <button type="button" [tabindex]="$index"
          class="absolute flex items-center justify-center w-8 h-8 -top-2 -right-2 text-white/50 hover:text-white/75"
          (click)="removeCondition(condition)">
          <nrc-icon [name]="'clear'" class="w-3 h-3" />
        </button>
      </div>
    }
  }

  <div class="flex items-center w-48 h-10 border border-dashed rounded-full transition-width bg-black/30 border-white/20" (click)="addCondition()" (keyup)="null" tabindex="0" role="button" aria-label="Add filter" aria-expanded="false">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center gap-1 px-4">
        <nrc-icon class="w-5 h-5 p-1 cursor-pointer" [fillColor]="'white'" [name]="'plus'" />

        <span class="text-sm text-white/70">Add filter</span>
      </div>

      <nrc-icon class="p-2 cursor-pointer w-7 h-7" [fillColor]="'white'" [name]="'arrow-down'"/>
    </div>
  </div>

</div>